import { connect } from 'react-redux';
import { dispatchOrder } from '../../order';
import { FormattedMessage } from 'react-intl';
import { getStep } from '../../steps';
import { selectLocation } from '../../../addressbook/locations';
import Address from '../../../addressbook/components/Address';
import Alert from '../../../../ui/Alert';
import Button from '../../../../ui/Button';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Positions from './position/Positions';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Summary.scss';
import {withRouter} from "react-router-dom";

export class SummaryStep extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        location: ImmutablePropTypes.map.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        products: ImmutablePropTypes.map.isRequired,
        services: ImmutablePropTypes.map.isRequired,
        step: ImmutablePropTypes.map.isRequired,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    handleDispatchOrder = () => {
        const { order, dispatch } = this.props;
        dispatch(dispatchOrder(order));
    }

    render() {
        const { services, order, location } = this.props;

        // TODO: This can/should be extracted into a selector
        const orderedPositions = order.get('positions').reduce((result, positions) => {
            return result.concat(positions.keySeq().toList());
        }, Immutable.List());

        // TODO: We reduce the positions to only the selected positions since
        // the <Position> component renders all available positions. Check with
        // Julien if this is the way to go.
        const positions = this.props.products.filter(pos => {
            return orderedPositions.includes(pos.get('id'));
        });

        return (
            <div className={styles.container}>
                <h1>
                    <FormattedMessage id={'frontend.form_order_summary.headline.order_summary'} />
                </h1>

                {/* Info */}
                <Alert type='info' className={styles.block}>
                    <FormattedMessage id={'frontend.form_order_summary.text.check_confirm'} />
                </Alert>

                {/* Address */}
                <h2>
                    <FormattedMessage id={'frontend.form_order_summary.headline.selected_address'} />
                </h2>
                <Address location={location} />

                {/* Products */}
                <h2>
                    <FormattedMessage id={'frontend.form_order_summary.headline.selected_products'} />
                </h2>
                <Positions
                    positions={positions}
                    services={services}
                    order={order}
                    isEditable={false}
                />

                {/* Actions */}
                <div className={styles.actions}>
                    <Button
                        block
                        emphasis='primary'
                        onClick={this.handleDispatchOrder}
                    >
                        <FormattedMessage id='frontend.form_order_summary.button.continue' />
                    </Button>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(state => ({
    location: selectLocation(state, state.order.get('location')),
    order: state.order,
    products: state.products,
    services: state.services,
    step: getStep(state, 'summary'),
}))(SummaryStep));
